export enum SideSectionAction {
    OPEN = 'SideSheetAction.OPEN',
    CLOSE = 'SideSheetAction.CLOSE',
    CLOSED = 'SideSheetAction.CLOSED'
}